import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { IScrollToTop } from "./ScrollToTopInterface";

function ScrollToTop({ children }: IScrollToTop) {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return <>{children}</>;
}

export default ScrollToTop;
